export const pillType = {
  CURRENT: 'CURRENT',
  DONE: 'DONE',
  NOT_DONE: 'NOT_DONE',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  DANGER: 'DANGER',
  NEUTRAL: 'NEUTRAL',
};
